module.exports = __webpack_public_path__ + "img/Discount45.327f884b.png";